export const memoryIntroText = (
    <>
        <p>
            O <strong>Memory Lab</strong> é uma ferramenta interativa criada para testar e treinar a memória de curto prazo através de desafios progressivos.
        </p>

        <p>
            O objetivo é simular situações em que o cérebro precisa <strong>armazenar e recuperar informações rapidamente</strong>, como sequências numéricas e padrões simples.
        </p>

        <p>
            À medida que você acerta, a dificuldade aumenta, estimulando:
        </p>

        <ul>
            <li>🧠 Atenção</li>
            <li>⚡ Velocidade de processamento</li>
            <li>🎯 Foco mental</li>
        </ul>

        <p>
            Esse tipo de treino ajuda a melhorar o desempenho cognitivo no dia a dia, tornando sua mente mais rápida e eficiente.
        </p>
    </>
);